var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeleteIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#004165",
  d: "M1.143 17.778C1.143 19 2.17 20 3.429 20h9.142c1.258 0 2.286-1 2.286-2.222V4.444H1.143zM16 1.11h-4L10.857 0H5.143L4 1.111H0v2.222h16z"
})));
export { SvgDeleteIcon as ReactComponent };
export default __webpack_public_path__ + "3ed8f09efe7d3548564f6320d66fdfe1.svg";